import React from 'react';
import { useRoute } from '@react-navigation/native';

import drawerHoc from '../../components/drawerHOC/DrawerHOC';
import Reports from './reports/Reports';

const MaintenanceProjectScreen = () => {
  const route = useRoute();
  const initialTab = route?.params?.tab ?? 0;

  return <Reports initialTab={initialTab} />;
};

export default drawerHoc({
  Component: MaintenanceProjectScreen,
  showBackButton: true,
  customWidth: '90%',
});
